var _circle, _path, _g, _g2, _ellipse, _ellipse2, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#EAF2FF",
    stroke: "url(#paint0_linear_623_67)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8691 33.2956C47.8691 30.3709 50.2545 28 53.197 28H70.6724C73.6149 28 76.0003 30.3709 76.0003 33.2956V42.4039C76.0003 45.3286 73.6149 47.6995 70.6724 47.6995H53.197C50.2545 47.6995 47.8691 45.3286 47.8691 42.4039V33.2956Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_623_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3607 51.936C62.3607 62.4648 53.7733 71 43.1803 71C32.5873 71 24 62.4648 24 51.936C24 41.4072 32.5873 32.8719 43.1803 32.8719C53.7733 32.8719 62.3607 41.4072 62.3607 51.936Z",
    fill: "url(#paint1_linear_623_67)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3607 51.936C62.3607 62.4648 53.7733 71 43.1803 71C32.5873 71 24 62.4648 24 51.936C24 41.4072 32.5873 32.8719 43.1803 32.8719C53.7733 32.8719 62.3607 41.4072 62.3607 51.936Z",
    stroke: "url(#paint2_linear_623_67)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_623_67)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1803 70.8941C53.7145 70.8941 62.2541 62.4063 62.2541 51.936C62.2541 41.4657 53.7145 32.9779 43.1803 32.9779C32.6462 32.9779 24.1066 41.4657 24.1066 51.936C24.1066 62.4063 32.6462 70.8941 43.1803 70.8941ZM43.1803 71C53.7733 71 62.3607 62.4648 62.3607 51.936C62.3607 41.4072 53.7733 32.8719 43.1803 32.8719C32.5873 32.8719 24 41.4072 24 51.936C24 62.4648 32.5873 71 43.1803 71Z",
    fill: "url(#paint3_linear_623_67)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1803 70.8941C53.7145 70.8941 62.2541 62.4063 62.2541 51.936C62.2541 41.4657 53.7145 32.9779 43.1803 32.9779C32.6462 32.9779 24.1066 41.4657 24.1066 51.936C24.1066 62.4063 32.6462 70.8941 43.1803 70.8941ZM43.1803 71C53.7733 71 62.3607 62.4648 62.3607 51.936C62.3607 41.4072 53.7733 32.8719 43.1803 32.8719C32.5873 32.8719 24 41.4072 24 51.936C24 62.4648 32.5873 71 43.1803 71Z",
    fill: "url(#paint4_radial_623_67)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1478,
    cy: 47.6995,
    rx: 2.13115,
    ry: 2.11823,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.0003,
    cy: 47.6995,
    rx: 2.13115,
    ry: 2.11823,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3258 55.2907C48.9501 55.6014 49.2108 56.3695 48.7915 56.9268C48.2403 57.6596 47.5492 58.2827 46.7535 58.7584C45.5931 59.452 44.2583 59.8033 42.9046 59.7714C41.551 59.7395 40.2344 59.3257 39.1085 58.5782C38.3364 58.0656 37.6758 57.4106 37.1601 56.6528C36.7678 56.0762 37.0646 55.3214 37.7029 55.0405V55.0405C38.3371 54.7614 39.0665 55.0636 39.5088 55.5971C39.7945 55.9418 40.1307 56.2449 40.5081 56.4954C41.2366 56.9791 42.0885 57.2469 42.9644 57.2675C43.8403 57.2882 44.704 57.0608 45.4547 56.612C45.844 56.3794 46.1945 56.0922 46.4965 55.761C46.9632 55.2493 47.7057 54.9822 48.3258 55.2907V55.2907Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.538 41.167C62.0933 41.167 61.7067 41.0123 61.378 40.703C61.0687 40.3743 60.914 39.9877 60.914 39.543V37.832C60.914 35.976 61.7067 34.5647 63.292 33.598C63.4273 33.5013 63.5917 33.453 63.785 33.453C64.017 33.453 64.2103 33.54 64.365 33.714C64.539 33.888 64.626 34.091 64.626 34.323C64.626 34.6323 64.481 34.874 64.191 35.048C63.7077 35.338 63.3403 35.6763 63.089 36.063C62.8377 36.4497 62.712 37.0103 62.712 37.745H62.828C63.2727 37.745 63.6497 37.9093 63.959 38.238C64.2877 38.5473 64.452 38.9243 64.452 39.369V39.543C64.452 39.9877 64.2877 40.3743 63.959 40.703C63.6497 41.0123 63.2727 41.167 62.828 41.167H62.538ZM67.787 41.167C67.3423 41.167 66.9557 41.0123 66.627 40.703C66.3177 40.3743 66.163 39.9877 66.163 39.543V37.832C66.163 35.976 66.9557 34.5647 68.541 33.598C68.6763 33.5013 68.8407 33.453 69.034 33.453C69.266 33.453 69.4593 33.54 69.614 33.714C69.788 33.888 69.875 34.091 69.875 34.323C69.875 34.6323 69.73 34.874 69.44 35.048C68.9567 35.338 68.5893 35.6763 68.338 36.063C68.0867 36.4497 67.961 37.0103 67.961 37.745H68.077C68.5217 37.745 68.8987 37.9093 69.208 38.238C69.5367 38.5473 69.701 38.9243 69.701 39.369V39.543C69.701 39.9877 69.5367 40.3743 69.208 40.703C68.8987 41.0123 68.5217 41.167 68.077 41.167H67.787Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_623_67",
    x: 21.85,
    y: 30.7219,
    width: 42.6604,
    height: 42.4281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_67"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_67",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_623_67",
    x: -6,
    y: 2.87195,
    width: 98.3604,
    height: 98.1281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_623_67"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_623_67",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_67",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D0CCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_67",
    x1: 28.105,
    y1: 36.3897,
    x2: 69.4034,
    y2: 57.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#393184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_67",
    x1: 46.3771,
    y1: 39.2266,
    x2: 60.6151,
    y2: 72.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_623_67",
    x1: 29.5205,
    y1: 31.5102,
    x2: 65.3657,
    y2: 52.5666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188941,
    stopColor: "#E7F0FF",
    stopOpacity: 0.523483
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#88A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_623_67",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7329 69.7518) rotate(-50.8068) scale(30.0156 49.1399)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteGlassIcon);
export default __webpack_public_path__ + "static/media/quote-glass-icon.230fdf357fb80d5a354e3f746e5f656e.svg";
export { ForwardRef as ReactComponent };